// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/feature/hotel/hotel_preferences.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";
import { file_proto_model_feature_hotel_hotel_types } from "./hotel_types_pb";

/**
 * Describes the file proto/model/feature/hotel/hotel_preferences.proto.
 */
export const file_proto_model_feature_hotel_hotel_preferences = /*@__PURE__*/
  fileDesc("CjFwcm90by9tb2RlbC9mZWF0dXJlL2hvdGVsL2hvdGVsX3ByZWZlcmVuY2VzLnByb3RvEgZjYXJtZW4ikQMKEEhvdGVsUHJlZmVyZW5jZXMSMAoVcHJlZmVycmVkX2hvdGVsX3R5cGVzGAEgAygOMhEuY2FybWVuLkhvdGVsVHlwZRIuChNhdm9pZGVkX2hvdGVsX3R5cGVzGAIgAygOMhEuY2FybWVuLkhvdGVsVHlwZRIbChNwcmVmZXJyZWRfYW1lbml0aWVzGAMgAygJEhkKEWF2b2lkZWRfYW1lbml0aWVzGAQgAygJEjEKEGZsb29yX3ByZWZlcmVuY2UYBSABKA4yFy5jYXJtZW4uRmxvb3JQcmVmZXJlbmNlEisKEnByZWZlcnJlZF9iZWRfdHlwZRgGIAEoDjIPLmNhcm1lbi5CZWRUeXBlEkEKGXJvb21fbG9jYXRpb25fcHJlZmVyZW5jZXMYByADKA4yHi5jYXJtZW4uUm9vbUxvY2F0aW9uUHJlZmVyZW5jZRIiChphY2Nlc3NpYmlsaXR5X3JlcXVpcmVtZW50cxgIIAMoCRIcChRkaWV0YXJ5X3JlcXVpcmVtZW50cxgJIAMoCSqcAQoPRmxvb3JQcmVmZXJlbmNlEiAKHEZMT09SX1BSRUZFUkVOQ0VfVU5TUEVDSUZJRUQQABIYChRGTE9PUl9QUkVGRVJFTkNFX0xPVxABEhgKFEZMT09SX1BSRUZFUkVOQ0VfTUlEEAISGQoVRkxPT1JfUFJFRkVSRU5DRV9ISUdIEAMSGAoURkxPT1JfUFJFRkVSRU5DRV9UT1AQBCqAAgoWUm9vbUxvY2F0aW9uUHJlZmVyZW5jZRIoCiRST09NX0xPQ0FUSU9OX1BSRUZFUkVOQ0VfVU5TUEVDSUZJRUQQABIiCh5ST09NX0xPQ0FUSU9OX1BSRUZFUkVOQ0VfUVVJRVQQARIlCiFST09NX0xPQ0FUSU9OX1BSRUZFUkVOQ0VfRUxFVkFUT1IQAhIjCh9ST09NX0xPQ0FUSU9OX1BSRUZFUkVOQ0VfU1RBSVJTEAMSIwofUk9PTV9MT0NBVElPTl9QUkVGRVJFTkNFX0NPUk5FUhAEEicKI1JPT01fTE9DQVRJT05fUFJFRkVSRU5DRV9DT05ORUNUSU5HEAUqoQEKEVNtb2tpbmdQcmVmZXJlbmNlEiIKHlNNT0tJTkdfUFJFRkVSRU5DRV9VTlNQRUNJRklFRBAAEiIKHlNNT0tJTkdfUFJFRkVSRU5DRV9OT05fU01PS0lORxABEh4KGlNNT0tJTkdfUFJFRkVSRU5DRV9TTU9LSU5HEAISJAogU01PS0lOR19QUkVGRVJFTkNFX05PX1BSRUZFUkVOQ0UQA0I2WjRnaXRodWIuY29tL3l1bmFjYWJhL2Nhcm1lbi9wcm90by9tb2RlbC9mZWF0dXJlL2hvdGVsYgZwcm90bzM", [file_proto_model_feature_hotel_hotel_types]);

/**
 * Describes the message carmen.HotelPreferences.
 * Use `create(HotelPreferencesSchema)` to create a new message.
 */
export const HotelPreferencesSchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_hotel_hotel_preferences, 0);

/**
 * Describes the enum carmen.FloorPreference.
 */
export const FloorPreferenceSchema = /*@__PURE__*/
  enumDesc(file_proto_model_feature_hotel_hotel_preferences, 0);

/**
 * @generated from enum carmen.FloorPreference
 */
export const FloorPreference = /*@__PURE__*/
  tsEnum(FloorPreferenceSchema);

/**
 * Describes the enum carmen.RoomLocationPreference.
 */
export const RoomLocationPreferenceSchema = /*@__PURE__*/
  enumDesc(file_proto_model_feature_hotel_hotel_preferences, 1);

/**
 * @generated from enum carmen.RoomLocationPreference
 */
export const RoomLocationPreference = /*@__PURE__*/
  tsEnum(RoomLocationPreferenceSchema);

/**
 * Describes the enum carmen.SmokingPreference.
 */
export const SmokingPreferenceSchema = /*@__PURE__*/
  enumDesc(file_proto_model_feature_hotel_hotel_preferences, 2);

/**
 * @generated from enum carmen.SmokingPreference
 */
export const SmokingPreference = /*@__PURE__*/
  tsEnum(SmokingPreferenceSchema);

